<div class="wrapper" [class.small]="small">
  <img [src]="imageSource" />
</div>
